type IconProps = React.ComponentProps<'svg'>

export function Scissors01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 0c2.07107 0 3.75 1.67893 3.75 3.75 0 0.76427-0.22947 1.47458-0.62207 2.06738l2.87207 2.87207 7.46973-7.46972c0.29289-0.29289 0.76765-0.29289 1.06054 0 0.29289 0.29289 0.29289 0.76765 0 1.06054l-7.46972 7.46973 7.46972 7.46973c0.29289 0.29289 0.29289 0.76765 0 1.06054-0.29289 0.29289-0.76765 0.29289-1.06054 0l-7.46973-7.46972-2.87207 2.87109c0.39287 0.59294 0.62207 1.3038 0.62207 2.06836 0 2.07107-1.67893 3.75-3.75 3.75-2.07107 0-3.75-1.67893-3.75-3.75 0-2.07107 1.67893-3.75 3.75-3.75 0.76407 0 1.47467 0.22868 2.06738 0.62109l2.87207-2.87109-2.87207-2.87207c-0.5928 0.3926-1.30312 0.62207-2.06738 0.62207-2.07107 0-3.75-1.67893-3.75-3.75 0-2.07107 1.67893-3.75 3.75-3.75z m0 13.5c-1.24264 0-2.25 1.00736-2.25 2.25 0 1.24264 1.00736 2.25 2.25 2.25 1.24264 0 2.25-1.00736 2.25-2.25 0-1.24264-1.00736-2.25-2.25-2.25z m0-12c-1.24264 0-2.25 1.00736-2.25 2.25 0 1.24264 1.00736 2.25 2.25 2.25 1.24264 0 2.25-1.00736 2.25-2.25 0-1.24264-1.00736-2.25-2.25-2.25z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
